import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "./jsx.js";
import { useFetchCounter } from "./FetchTracker.js";
export function LoadingBar() {
    const counter = useFetchCounter();
    const loading = useMemo(() => {
        if (counter > 0) {
            return "loading-bar";
        }
        return "";
    }, [counter]);
    return (_jsx("div", { className: `fixed w-full h-1`, children: _jsx("div", { className: `bg-gray-500 h-full w-0 ${loading}` }) }));
}
